import { octaneClient } from 'src/utils/octane-client';

export function fetchNeighborhoodService(
  city: string,
  stateId: string,
  neighborhoodSlug: string,
  client = octaneClient,
) {
  return client.get<any>(
    `/geo/neighborhood/${city}/${stateId}/${neighborhoodSlug}`,
  );
}

export function fetchCityService(
  city: string,
  stateId: string,
  client = octaneClient,
) {
  return client.get<any>(`/geo/city/${city}/${stateId}`);
}

// Shapes for the two region-list endpoints below. These mirror the schemas
// `@belong/utils-regions` validates the same endpoints against in the new stack
// (`CitySchema` / `NeighborhoodSchema`); the other services in this file stay
// `any` because nothing has pinned their shapes down yet.
type CityListItem = {
  city?: string;
  stateId: string;
  // Required because `[cmsUid]` reads `city.region.name` without a guard. The
  // new-stack `CitySchema` does not model `region` at all — it only needs the
  // first two fields.
  region: { name?: string };
};

type NeighborhoodListItem = {
  neighborhood?: string;
  cityName?: string;
  stateId?: string;
};

export function fetchNeighborhoodListService(client = octaneClient) {
  return client.get<NeighborhoodListItem[]>('/geo/neighborhood/region/list');
}

export function fetchCityListService(client = octaneClient) {
  return client.get<CityListItem[]>('/geo/city/region/list');
}
